<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.artid"
        :remote-method="getRemoteArtList"
        filterable
        remote
        clearable
        placeholder="搜索品种"
        :loading="artLoading"
        class="filter-item"
        style="margin-right: 10px; width: 300px;"
      >
        <el-option
          v-for="(item,index) in artListOptions"
          :key="item.artid+index"
          :label="item.name"
          :value="item.artid"
        >
          <span style="margin-right: 15px; float: left; font-size: 13px">{{ item.artid }}</span>
          <span style="margin-right: 15px; color: #8492a6; font-size: 13px">[ {{ item.spec }} ]</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.name }}</span>
        </el-option>
      </el-select>
      <el-input
        v-model.trim="listQuery.customername"
        clearable
        placeholder="请输入往来单位"
        class="filter-item"
        @keyup.enter.native="getList"
        style="margin-right: 10px;width: 200px;"
      >
      </el-input>
      <el-select
        v-model="listQuery.billtypeidList"
        placeholder="票据类型"
        class="filter-item"
        multiple
        collapse-tags
        :loading="billtypeLoading"
        style="margin-right: 10px;"
      >
        <el-option
          v-for="item in billtypeListOptions"
          :key="item.billtyeid"
          :label="item.billtypename"
          :value="item.billtypeid"
        >
        </el-option>
      </el-select>
      <el-date-picker
        v-model="queryDate"
        type="daterange"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        class="filter-item"
        style="margin-right: 10px"
      ></el-date-picker>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
      <el-button
        :loading="downloadLoading"
        class="filter-item"
        type="primary"
        icon="el-icon-download"
        @click="handleDownload"
      >导出
      </el-button>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      ref="dataTable"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      :max-height="clientHeight"
      size="mini"
      @sort-change="sortChange"
      :default-sort="defaultSort"
    >
      <el-table-column align="center" label="品种编码" width="100" sortable="custom" prop="goodsid">
        <template slot-scope="scope">{{ scope.row.goodsid }}</template>
      </el-table-column>
      <el-table-column label="品名" align="center" width="200" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="规格" align="center" width="150" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.spec }}</template>
      </el-table-column>
      <el-table-column label="产家" align="center" width="250" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.factory }}</template>
      </el-table-column>
      <el-table-column label="装量" align="center" width="60">
        <template slot-scope="scope">{{ scope.row.packednumber }}</template>
      </el-table-column>
      <el-table-column label="单位" align="center" width="50">
        <template slot-scope="scope">{{ scope.row.unit }}</template>
      </el-table-column>
      <el-table-column
        label="审核时间"
        align="center"
        width="120"
        sortable="custom"
        prop="timevalidated"
      >
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          {{ scope.row.timevalidated }}
        </template>
      </el-table-column>
      <el-table-column
        label="往来单位"
        align="center"
        sortable="custom"
        prop="customername"
        width="200"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">{{ scope.row.customername }}</template>
      </el-table-column>
      <el-table-column
        label="业务类型"
        align="center"
        width="100"
        sortable="custom"
        prop="billtypename"
      >
        <template slot-scope="scope">{{ scope.row.billtypename }}</template>
      </el-table-column>
      <el-table-column
        label="批号"
        align="center"
        width="150"
        sortable="custom"
        prop="serial"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">{{ scope.row.serial }}</template>
      </el-table-column>
      <el-table-column label="数量" align="center" width="80">
        <template slot-scope="scope">{{ scope.row.total }}</template>
      </el-table-column>
      <el-table-column label="单价" align="center" width="80">
        <template slot-scope="scope">{{ scope.row.price }}</template>
      </el-table-column>
      <el-table-column label="金额" align="center" width="80">
        <template slot-scope="scope">{{ scope.row.amount }}</template>
      </el-table-column>
      <el-table-column v-if="keeper === '1'" label="ID" align="center" width="100" sortable="custom" prop="userid">
        <template slot-scope="scope">{{ scope.row.userid }}</template>
      </el-table-column>
      <el-table-column label="流水号" align="center" width="80">
        <template slot-scope="scope">{{ scope.row.bseqid }}</template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <pagination
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    >
    </pagination>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getDataPrice, artSearch, getExportPrice, billtypeSearch } from '@/api/flow'
import Pagination from '@/components/Pagination'

export default {
  name: 'ProductFlowPrice',
  components: {
    Pagination
  },

  filters: {},

  data() {
    return {
      clientHeight: '800',
      total: 0,
      list: null,
      allList: null,
      queryDate: [],
      artForm: {},
      artListOptions: [],
      billtypeListOptions: [],
      listQuery: {
        artid: null,
        customername:null,
        page: 1,
        limit: 10,
        startDate: '',
        endDate: '',
        columns: 'timevalidated',
        asc: false
      },
      defaultSort: { prop: 'timevalidated', order: 'descending' },
      listLoading: true,
      downloadLoading: false,
      artLoading: false,
      billtypeLoading: false
    }
  },

  created() {
    this.initHeight()
    this.getRemoteBilltypeList()
    this.getList()
  },

  mounted() {
    window.addEventListener('resize', this.initHeight)
  },

  computed: {
    ...mapGetters(['keeper'])
  },

  methods: {
    initHeight() {
      this.clientHeight = document.documentElement.clientHeight - 240
    },

    getList() {
      this.listLoading = true
      let [start, end] = this.queryDate || []
      this.listQuery.startDate = start
      this.listQuery.endDate = end
      getDataPrice(this.listQuery)
        .then(response => {
          this.list = response.data.items
          this.total = response.data.total
          this.listLoading = false
        })
        .catch(() => {
          this.listLoading = false
        })
    },

    // 搜索
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },

    // 获取可查品种
    getRemoteArtList(query) {
      if (query !== '') {
        this.artLoading = true
        setTimeout(() => {
          artSearch(query).then(response => {
            this.artLoading = false
            if (!response.data) return
            this.artListOptions = response.data
          })
        }, 1000)
      } else {
        this.listQuery.artid = null
      }
    },

    // 获取可查票据
    getRemoteBilltypeList() {
      this.artLoading = true
      setTimeout(() => {
        billtypeSearch().then(response => {
          this.billtypeLoading = false
          if (!response.data) return
          this.billtypeListOptions = response.data
        })
      }, 1000)
    },

    // 格式化数据
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j]
        })
      )
    },

    // 排序
    sortChange(column) {
      switch (column.order) {
        case 'ascending':
          this.listQuery.columns = column.prop
          this.listQuery.asc = true
          break
        case 'descending':
          this.listQuery.columns = column.prop
          this.listQuery.asc = false
          break
      }
      this.listQuery.page = 1
      this.getList()
    },

    // 导出事件
    handleDownload() {
      this.downloadLoading = true
      getExportPrice(this.listQuery).then(response => {
        this.allList = response.data
        import('@/vendor/Export2Excel')
          .then(excel => {
            const tHeader = [
              '品种编码',
              '品名',
              '规格',
              '产地',
              '装量',
              '单位',
              '审核时间',
              '往来单位',
              '业务类型',
              '批号',
              '数量',
              '单价',
              '金额',
              'ID',
              '流水号'
            ]
            const filterVal = [
              'goodsid',
              'name',
              'spec',
              'factory',
              'packednumber',
              'unit',
              'timevalidated',
              'customername',
              'billtypename',
              'serial',
              'total',
              'price',
              'amount',
              'userid',
              'bseqid'
            ]
            const data = this.formatJson(filterVal, this.allList)
            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: '商品流向（单价）'
            })
            this.downloadLoading = false
          })
          .catch(() => {
            this.downloadLoading = false
          })
      })
    }
  }
}
</script>
